module.exports = __webpack_public_path__ + "static/img/img_5.12aa5a9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_5.webp
// module id = WeQJ
// module chunks = 4